import { default as indexOLyv8R9jHNMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Aboutme/index.vue?macro=true";
import { default as indexHSs6OjeT10Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Aboutme/ts/index.ts?macro=true";
import { default as UserList11bQBUat50Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Aboutme/UserList.vue?macro=true";
import { default as ChatPagefQaCSqwUjVMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ChatPage.vue?macro=true";
import { default as ChatEditor71epZD8gXsMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatEditor.vue?macro=true";
import { default as ChatEmojinXUQdEn8yvMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatEmoji.vue?macro=true";
import { default as ChatItemppqCaMUTbNMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatItem.vue?macro=true";
import { default as ChatListcoUwMp1RMAMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatList.vue?macro=true";
import { default as indexPqjYbFyuvHMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/index.vue?macro=true";
import { default as chatPageeiXyj1AL4rMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ts/chatPage.ts?macro=true";
import { default as dataRsjseYAtXaMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ts/data.ts?macro=true";
import { default as indext8RuKZZZ8zMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ts/index.ts?macro=true";
import { default as AboutfE39VTw2TwMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Draftstatic/About.vue?macro=true";
import { default as PrivacyXmj4ODdf1bMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Draftstatic/Privacy.vue?macro=true";
import { default as indexxzTGxUhLX2Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/EditProfile/index.vue?macro=true";
import { default as indexXcbP6njsm5Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/EditProfile/ts/index.ts?macro=true";
import { default as CountryPopupbBUs5nTTs6Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/components/CountryPopup.vue?macro=true";
import { default as LiveListq0ySTsKuKaMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/components/LiveList.vue?macro=true";
import { default as PopularListg2V1MulYV0Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/components/PopularList.vue?macro=true";
import { default as index2tk1w2UGBkMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/index.vue?macro=true";
import { default as indexWGOCfBUJYpMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Match/index.vue?macro=true";
import { default as MatchingEzxCt69x7XMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Match/Matching.vue?macro=true";
import { default as RechargePopuprh2PXJ6MvbMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/components/RechargePopup.vue?macro=true";
import { default as indexAagA2T1aOrMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/components/ts/index.ts?macro=true";
import { default as indexFGE4VEUN9oMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/index.vue?macro=true";
import { default as ResultJsdkWMNIhEMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/Result.vue?macro=true";
import { default as dataZMcK4Qx7i2Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/ts/data.ts?macro=true";
import { default as indexOCswFlYcnWMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/ts/index.ts?macro=true";
import { default as resultZdzSfa2Os4Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/ts/result.ts?macro=true";
import { default as Audio0jytXSjq7EMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/Audio.vue?macro=true";
import { default as Callr6gjEVLm9SMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/Call.vue?macro=true";
import { default as CallWaitingjM1dahw5tLMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/CallWaiting.vue?macro=true";
import { default as ActionSheetosL8uDsw61Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ActionSheet.vue?macro=true";
import { default as EffectGiftACaAJAQxxGMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectGift.vue?macro=true";
import { default as EffectHeadwearKmBucX1i78Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectHeadwear.vue?macro=true";
import { default as EmojiAnimation82wu3mVymeMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/EmojiAnimation.vue?macro=true";
import { default as GiftListAnimationMyUik5Z8ZuMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/GiftListAnimation.vue?macro=true";
import { default as GiftListAnimationItemD0J8r98ymqMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/GiftListAnimationItem.vue?macro=true";
import { default as MicGiftAnimation9gYxjj8PNtMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/MicGiftAnimation.vue?macro=true";
import { default as MicGiftAnimationItemV7H7o4tIUTMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/MicGiftAnimationItem.vue?macro=true";
import { default as AgoraAudiom1eCWCP0aYMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/AgoraAudio.vue?macro=true";
import { default as DefaultBgV90axzMiZ4Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/DefaultBg.vue?macro=true";
import { default as MicListQU4QBGhSixMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/MicList.vue?macro=true";
import { default as TrtcAudiovzyS5Sd2cmMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/TrtcAudio.vue?macro=true";
import { default as CallTipsIx44Yx9DUdMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/CallTips.vue?macro=true";
import { default as ChatEditormhpzpT1uZ0Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatEditor.vue?macro=true";
import { default as ChatList8GSPOVSvpbMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatList.vue?macro=true";
import { default as ChatListItemAtDVG5nwAeMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatListItem.vue?macro=true";
import { default as ChatListSlideRfFrI5kuJnMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatListSlide.vue?macro=true";
import { default as InviteUserr11V2NToTpMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/InviteUser.vue?macro=true";
import { default as OnlineUserPopupfXDvbO3BEuMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/OnlineUserPopup.vue?macro=true";
import { default as EmojiPopupGTlGquUWLuMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/popup/EmojiPopup.vue?macro=true";
import { default as RoomFootdnC4k7XgSDMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomFoot.vue?macro=true";
import { default as RoomHeadLl3GBCjV0VMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomHead.vue?macro=true";
import { default as RoomPasswordDialog8S4WxfUnCnMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomPasswordDialog.vue?macro=true";
import { default as RoomSheetFCyydeHd1QMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomSheet.vue?macro=true";
import { default as AgoraLivet6Ewaa1SRVMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/AgoraLive.vue?macro=true";
import { default as AgoraLivePkHgXDVhpny7Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/AgoraLivePk.vue?macro=true";
import { default as AgoraVideoPlayerDl07UJ45vVMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/AgoraVideoPlayer.vue?macro=true";
import { default as CountdownOverlay7bJulLO2ShMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/CountdownOverlay.vue?macro=true";
import { default as LivePkdYwslCSqXEMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/LivePk.vue?macro=true";
import { default as PKResultOverlay0PEQwIdplJMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/PKResultOverlay.vue?macro=true";
import { default as TrtcLiveomWXMSbhgnMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/TrtcLive.vue?macro=true";
import { default as VideoBackgroundWerkadMHuhMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/VideoBackground.vue?macro=true";
import { default as VideoLoadMaskwzUSBBmKCgMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/VideoLoadMask.vue?macro=true";
import { default as LiveAClpRpDg5rMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/Live.vue?macro=true";
import { default as updateUserTimeStatusvd7BQA34ypMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/ts/updateUserTimeStatus.ts?macro=true";
import { default as AudioyhetY0I9QXMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/Audio.vue?macro=true";
import { default as CallKWvleZd3QfMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/Call.vue?macro=true";
import { default as ActionSheetfROYdjTRstMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ActionSheet.vue?macro=true";
import { default as ActivityCornerXSEnfvlNJdMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ActivityCorner.vue?macro=true";
import { default as EffectGiftGYRXDvtU3KMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/EffectGift.vue?macro=true";
import { default as EffectHeadwear5HCfLSj06mMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/EffectHeadwear.vue?macro=true";
import { default as EmojiAnimationyB1DauKrd0Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/EmojiAnimation.vue?macro=true";
import { default as GiftListAnimationtWsIlkEOI8Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/GiftListAnimation.vue?macro=true";
import { default as GiftListAnimationItemJ7Smh8buFMMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/GiftListAnimationItem.vue?macro=true";
import { default as LuckyBagBanner0Co9pd73WuMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/LuckyBagBanner.vue?macro=true";
import { default as MicGiftAnimation08k2H5rscAMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/MicGiftAnimation.vue?macro=true";
import { default as MicGiftAnimationItemZ3Qq2gZ70kMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/MicGiftAnimationItem.vue?macro=true";
import { default as AgoraAudiooPlXVy8lb9Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/AgoraAudio.vue?macro=true";
import { default as DefaultBgJHOiJQfdiBMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/DefaultBg.vue?macro=true";
import { default as MicList8tf1AuMcc7Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/MicList.vue?macro=true";
import { default as TrtcAudioo9iVq1RxctMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/TrtcAudio.vue?macro=true";
import { default as CallTips83ri2wiM2FMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/CallTips.vue?macro=true";
import { default as ChatEditor97iRI6Zcf7Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatEditor.vue?macro=true";
import { default as ChatList1Z1BiK68RGMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatList.vue?macro=true";
import { default as ChatListItem7brDd8KKnmMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatListItem.vue?macro=true";
import { default as ChatListSlideVMh3tng1YPMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatListSlide.vue?macro=true";
import { default as DetonatingBombrmltd602QkMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/DetonatingBomb.vue?macro=true";
import { default as InviteUserNoKNdpOerZMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/InviteUser.vue?macro=true";
import { default as LuckyBagn64lV07xBdMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/LuckyBag.vue?macro=true";
import { default as OnlineUserPopup3AYuslqrKJMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/OnlineUserPopup.vue?macro=true";
import { default as RoomFootAQw9osLnoQMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomFoot.vue?macro=true";
import { default as RoomHeadz8wFqrfJXtMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomHead.vue?macro=true";
import { default as RoomPasswordDialogbH2rpKCyguMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomPasswordDialog.vue?macro=true";
import { default as RoomSheettv56y7TuHIMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomSheet.vue?macro=true";
import { default as activityCornerYGD4vg9x6IMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ts/activityCorner.ts?macro=true";
import { default as AgoraLivee0B633cFD7Meta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/AgoraLive.vue?macro=true";
import { default as AgoraLivePkek0xNVXJxRMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/AgoraLivePk.vue?macro=true";
import { default as AgoraVideoPlayerlvlyBHslZZMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/AgoraVideoPlayer.vue?macro=true";
import { default as CountdownOverlay0ycQfUT00QMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/CountdownOverlay.vue?macro=true";
import { default as LivePkkgwJNtQxwIMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/LivePk.vue?macro=true";
import { default as PKResultOverlayspZVleE6ujMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/PKResultOverlay.vue?macro=true";
import { default as TrtcLivejJOqor97XwMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/TrtcLive.vue?macro=true";
import { default as VideoBackgroundpPgAFnWlPoMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/VideoBackground.vue?macro=true";
import { default as VideoLoadMask8Xq2MUM39iMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/VideoLoadMask.vue?macro=true";
import { default as LiveGOzMvSftCtMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/Live.vue?macro=true";
import { default as updateUserTimeStatusOxjtSaSVRrMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/ts/updateUserTimeStatus.ts?macro=true";
import { default as indexMn64kdgtjPMeta } from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Search/index.vue?macro=true";
export default [
  {
    name: indexOLyv8R9jHNMeta?.name ?? "Aboutme",
    path: indexOLyv8R9jHNMeta?.path ?? "/Aboutme",
    meta: indexOLyv8R9jHNMeta || {},
    alias: indexOLyv8R9jHNMeta?.alias || [],
    redirect: indexOLyv8R9jHNMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Aboutme/index.vue").then(m => m.default || m)
  },
  {
    name: indexHSs6OjeT10Meta?.name ?? "Aboutme-ts",
    path: indexHSs6OjeT10Meta?.path ?? "/Aboutme/ts",
    meta: indexHSs6OjeT10Meta || {},
    alias: indexHSs6OjeT10Meta?.alias || [],
    redirect: indexHSs6OjeT10Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Aboutme/ts/index.ts").then(m => m.default || m)
  },
  {
    name: UserList11bQBUat50Meta?.name ?? "Aboutme-UserList",
    path: UserList11bQBUat50Meta?.path ?? "/Aboutme/UserList",
    meta: UserList11bQBUat50Meta || {},
    alias: UserList11bQBUat50Meta?.alias || [],
    redirect: UserList11bQBUat50Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Aboutme/UserList.vue").then(m => m.default || m)
  },
  {
    name: ChatPagefQaCSqwUjVMeta?.name ?? "Chat-ChatPage",
    path: ChatPagefQaCSqwUjVMeta?.path ?? "/Chat/ChatPage",
    meta: ChatPagefQaCSqwUjVMeta || {},
    alias: ChatPagefQaCSqwUjVMeta?.alias || [],
    redirect: ChatPagefQaCSqwUjVMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ChatPage.vue").then(m => m.default || m)
  },
  {
    name: ChatEditor71epZD8gXsMeta?.name ?? "Chat-components-ChatEditor",
    path: ChatEditor71epZD8gXsMeta?.path ?? "/Chat/components/ChatEditor",
    meta: ChatEditor71epZD8gXsMeta || {},
    alias: ChatEditor71epZD8gXsMeta?.alias || [],
    redirect: ChatEditor71epZD8gXsMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatEditor.vue").then(m => m.default || m)
  },
  {
    name: ChatEmojinXUQdEn8yvMeta?.name ?? "Chat-components-ChatEmoji",
    path: ChatEmojinXUQdEn8yvMeta?.path ?? "/Chat/components/ChatEmoji",
    meta: ChatEmojinXUQdEn8yvMeta || {},
    alias: ChatEmojinXUQdEn8yvMeta?.alias || [],
    redirect: ChatEmojinXUQdEn8yvMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatEmoji.vue").then(m => m.default || m)
  },
  {
    name: ChatItemppqCaMUTbNMeta?.name ?? "Chat-components-ChatItem",
    path: ChatItemppqCaMUTbNMeta?.path ?? "/Chat/components/ChatItem",
    meta: ChatItemppqCaMUTbNMeta || {},
    alias: ChatItemppqCaMUTbNMeta?.alias || [],
    redirect: ChatItemppqCaMUTbNMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatItem.vue").then(m => m.default || m)
  },
  {
    name: ChatListcoUwMp1RMAMeta?.name ?? "Chat-components-ChatList",
    path: ChatListcoUwMp1RMAMeta?.path ?? "/Chat/components/ChatList",
    meta: ChatListcoUwMp1RMAMeta || {},
    alias: ChatListcoUwMp1RMAMeta?.alias || [],
    redirect: ChatListcoUwMp1RMAMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/components/ChatList.vue").then(m => m.default || m)
  },
  {
    name: indexPqjYbFyuvHMeta?.name ?? "Chat",
    path: indexPqjYbFyuvHMeta?.path ?? "/Chat",
    meta: indexPqjYbFyuvHMeta || {},
    alias: indexPqjYbFyuvHMeta?.alias || [],
    redirect: indexPqjYbFyuvHMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/index.vue").then(m => m.default || m)
  },
  {
    name: chatPageeiXyj1AL4rMeta?.name ?? "Chat-ts-chatPage",
    path: chatPageeiXyj1AL4rMeta?.path ?? "/Chat/ts/chatPage",
    meta: chatPageeiXyj1AL4rMeta || {},
    alias: chatPageeiXyj1AL4rMeta?.alias || [],
    redirect: chatPageeiXyj1AL4rMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ts/chatPage.ts").then(m => m.default || m)
  },
  {
    name: dataRsjseYAtXaMeta?.name ?? "Chat-ts-data",
    path: dataRsjseYAtXaMeta?.path ?? "/Chat/ts/data",
    meta: dataRsjseYAtXaMeta || {},
    alias: dataRsjseYAtXaMeta?.alias || [],
    redirect: dataRsjseYAtXaMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ts/data.ts").then(m => m.default || m)
  },
  {
    name: indext8RuKZZZ8zMeta?.name ?? "Chat-ts",
    path: indext8RuKZZZ8zMeta?.path ?? "/Chat/ts",
    meta: indext8RuKZZZ8zMeta || {},
    alias: indext8RuKZZZ8zMeta?.alias || [],
    redirect: indext8RuKZZZ8zMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Chat/ts/index.ts").then(m => m.default || m)
  },
  {
    name: AboutfE39VTw2TwMeta?.name ?? "Draftstatic-About",
    path: AboutfE39VTw2TwMeta?.path ?? "/Draftstatic/About",
    meta: AboutfE39VTw2TwMeta || {},
    alias: AboutfE39VTw2TwMeta?.alias || [],
    redirect: AboutfE39VTw2TwMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Draftstatic/About.vue").then(m => m.default || m)
  },
  {
    name: PrivacyXmj4ODdf1bMeta?.name ?? "Draftstatic-Privacy",
    path: PrivacyXmj4ODdf1bMeta?.path ?? "/Draftstatic/Privacy",
    meta: PrivacyXmj4ODdf1bMeta || {},
    alias: PrivacyXmj4ODdf1bMeta?.alias || [],
    redirect: PrivacyXmj4ODdf1bMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Draftstatic/Privacy.vue").then(m => m.default || m)
  },
  {
    name: indexxzTGxUhLX2Meta?.name ?? "EditProfile",
    path: indexxzTGxUhLX2Meta?.path ?? "/EditProfile",
    meta: indexxzTGxUhLX2Meta || {},
    alias: indexxzTGxUhLX2Meta?.alias || [],
    redirect: indexxzTGxUhLX2Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/EditProfile/index.vue").then(m => m.default || m)
  },
  {
    name: indexXcbP6njsm5Meta?.name ?? "EditProfile-ts",
    path: indexXcbP6njsm5Meta?.path ?? "/EditProfile/ts",
    meta: indexXcbP6njsm5Meta || {},
    alias: indexXcbP6njsm5Meta?.alias || [],
    redirect: indexXcbP6njsm5Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/EditProfile/ts/index.ts").then(m => m.default || m)
  },
  {
    name: CountryPopupbBUs5nTTs6Meta?.name ?? "Home-components-CountryPopup",
    path: CountryPopupbBUs5nTTs6Meta?.path ?? "/Home/components/CountryPopup",
    meta: CountryPopupbBUs5nTTs6Meta || {},
    alias: CountryPopupbBUs5nTTs6Meta?.alias || [],
    redirect: CountryPopupbBUs5nTTs6Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/components/CountryPopup.vue").then(m => m.default || m)
  },
  {
    name: LiveListq0ySTsKuKaMeta?.name ?? "Home-components-LiveList",
    path: LiveListq0ySTsKuKaMeta?.path ?? "/Home/components/LiveList",
    meta: LiveListq0ySTsKuKaMeta || {},
    alias: LiveListq0ySTsKuKaMeta?.alias || [],
    redirect: LiveListq0ySTsKuKaMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/components/LiveList.vue").then(m => m.default || m)
  },
  {
    name: PopularListg2V1MulYV0Meta?.name ?? "Home-components-PopularList",
    path: PopularListg2V1MulYV0Meta?.path ?? "/Home/components/PopularList",
    meta: PopularListg2V1MulYV0Meta || {},
    alias: PopularListg2V1MulYV0Meta?.alias || [],
    redirect: PopularListg2V1MulYV0Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/components/PopularList.vue").then(m => m.default || m)
  },
  {
    name: index2tk1w2UGBkMeta?.name ?? "Home",
    path: index2tk1w2UGBkMeta?.path ?? "/Home",
    meta: index2tk1w2UGBkMeta || {},
    alias: index2tk1w2UGBkMeta?.alias || [],
    redirect: index2tk1w2UGBkMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Home/index.vue").then(m => m.default || m)
  },
  {
    name: indexWGOCfBUJYpMeta?.name ?? "Match",
    path: indexWGOCfBUJYpMeta?.path ?? "/Match",
    meta: indexWGOCfBUJYpMeta || {},
    alias: indexWGOCfBUJYpMeta?.alias || [],
    redirect: indexWGOCfBUJYpMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Match/index.vue").then(m => m.default || m)
  },
  {
    name: MatchingEzxCt69x7XMeta?.name ?? "Match-Matching",
    path: MatchingEzxCt69x7XMeta?.path ?? "/Match/Matching",
    meta: MatchingEzxCt69x7XMeta || {},
    alias: MatchingEzxCt69x7XMeta?.alias || [],
    redirect: MatchingEzxCt69x7XMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Match/Matching.vue").then(m => m.default || m)
  },
  {
    name: RechargePopuprh2PXJ6MvbMeta?.name ?? "Recharge-components-RechargePopup",
    path: RechargePopuprh2PXJ6MvbMeta?.path ?? "/Recharge/components/RechargePopup",
    meta: RechargePopuprh2PXJ6MvbMeta || {},
    alias: RechargePopuprh2PXJ6MvbMeta?.alias || [],
    redirect: RechargePopuprh2PXJ6MvbMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/components/RechargePopup.vue").then(m => m.default || m)
  },
  {
    name: indexAagA2T1aOrMeta?.name ?? "Recharge-components-ts",
    path: indexAagA2T1aOrMeta?.path ?? "/Recharge/components/ts",
    meta: indexAagA2T1aOrMeta || {},
    alias: indexAagA2T1aOrMeta?.alias || [],
    redirect: indexAagA2T1aOrMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/components/ts/index.ts").then(m => m.default || m)
  },
  {
    name: indexFGE4VEUN9oMeta?.name ?? "Recharge",
    path: indexFGE4VEUN9oMeta?.path ?? "/Recharge",
    meta: indexFGE4VEUN9oMeta || {},
    alias: indexFGE4VEUN9oMeta?.alias || [],
    redirect: indexFGE4VEUN9oMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/index.vue").then(m => m.default || m)
  },
  {
    name: ResultJsdkWMNIhEMeta?.name ?? "Recharge-Result",
    path: ResultJsdkWMNIhEMeta?.path ?? "/Recharge/Result",
    meta: ResultJsdkWMNIhEMeta || {},
    alias: ResultJsdkWMNIhEMeta?.alias || [],
    redirect: ResultJsdkWMNIhEMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/Result.vue").then(m => m.default || m)
  },
  {
    name: dataZMcK4Qx7i2Meta?.name ?? "Recharge-ts-data",
    path: dataZMcK4Qx7i2Meta?.path ?? "/Recharge/ts/data",
    meta: dataZMcK4Qx7i2Meta || {},
    alias: dataZMcK4Qx7i2Meta?.alias || [],
    redirect: dataZMcK4Qx7i2Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/ts/data.ts").then(m => m.default || m)
  },
  {
    name: indexOCswFlYcnWMeta?.name ?? "Recharge-ts",
    path: indexOCswFlYcnWMeta?.path ?? "/Recharge/ts",
    meta: indexOCswFlYcnWMeta || {},
    alias: indexOCswFlYcnWMeta?.alias || [],
    redirect: indexOCswFlYcnWMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/ts/index.ts").then(m => m.default || m)
  },
  {
    name: resultZdzSfa2Os4Meta?.name ?? "Recharge-ts-result",
    path: resultZdzSfa2Os4Meta?.path ?? "/Recharge/ts/result",
    meta: resultZdzSfa2Os4Meta || {},
    alias: resultZdzSfa2Os4Meta?.alias || [],
    redirect: resultZdzSfa2Os4Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Recharge/ts/result.ts").then(m => m.default || m)
  },
  {
    name: Audio0jytXSjq7EMeta?.name ?? "Room-Audio",
    path: Audio0jytXSjq7EMeta?.path ?? "/Room/Audio",
    meta: Audio0jytXSjq7EMeta || {},
    alias: Audio0jytXSjq7EMeta?.alias || [],
    redirect: Audio0jytXSjq7EMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/Audio.vue").then(m => m.default || m)
  },
  {
    name: Callr6gjEVLm9SMeta?.name ?? "Room-Call",
    path: Callr6gjEVLm9SMeta?.path ?? "/Room/Call",
    meta: Callr6gjEVLm9SMeta || {},
    alias: Callr6gjEVLm9SMeta?.alias || [],
    redirect: Callr6gjEVLm9SMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/Call.vue").then(m => m.default || m)
  },
  {
    name: CallWaitingjM1dahw5tLMeta?.name ?? "Room-CallWaiting",
    path: CallWaitingjM1dahw5tLMeta?.path ?? "/Room/CallWaiting",
    meta: CallWaitingjM1dahw5tLMeta || {},
    alias: CallWaitingjM1dahw5tLMeta?.alias || [],
    redirect: CallWaitingjM1dahw5tLMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/CallWaiting.vue").then(m => m.default || m)
  },
  {
    name: ActionSheetosL8uDsw61Meta?.name ?? "Room-components-ActionSheet",
    path: ActionSheetosL8uDsw61Meta?.path ?? "/Room/components/ActionSheet",
    meta: ActionSheetosL8uDsw61Meta || {},
    alias: ActionSheetosL8uDsw61Meta?.alias || [],
    redirect: ActionSheetosL8uDsw61Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ActionSheet.vue").then(m => m.default || m)
  },
  {
    name: EffectGiftACaAJAQxxGMeta?.name ?? "Room-components-animation-EffectGift",
    path: EffectGiftACaAJAQxxGMeta?.path ?? "/Room/components/animation/EffectGift",
    meta: EffectGiftACaAJAQxxGMeta || {},
    alias: EffectGiftACaAJAQxxGMeta?.alias || [],
    redirect: EffectGiftACaAJAQxxGMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectGift.vue").then(m => m.default || m)
  },
  {
    name: EffectHeadwearKmBucX1i78Meta?.name ?? "Room-components-animation-EffectHeadwear",
    path: EffectHeadwearKmBucX1i78Meta?.path ?? "/Room/components/animation/EffectHeadwear",
    meta: EffectHeadwearKmBucX1i78Meta || {},
    alias: EffectHeadwearKmBucX1i78Meta?.alias || [],
    redirect: EffectHeadwearKmBucX1i78Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/EffectHeadwear.vue").then(m => m.default || m)
  },
  {
    name: EmojiAnimation82wu3mVymeMeta?.name ?? "Room-components-animation-EmojiAnimation",
    path: EmojiAnimation82wu3mVymeMeta?.path ?? "/Room/components/animation/EmojiAnimation",
    meta: EmojiAnimation82wu3mVymeMeta || {},
    alias: EmojiAnimation82wu3mVymeMeta?.alias || [],
    redirect: EmojiAnimation82wu3mVymeMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/EmojiAnimation.vue").then(m => m.default || m)
  },
  {
    name: GiftListAnimationMyUik5Z8ZuMeta?.name ?? "Room-components-animation-GiftListAnimation",
    path: GiftListAnimationMyUik5Z8ZuMeta?.path ?? "/Room/components/animation/GiftListAnimation",
    meta: GiftListAnimationMyUik5Z8ZuMeta || {},
    alias: GiftListAnimationMyUik5Z8ZuMeta?.alias || [],
    redirect: GiftListAnimationMyUik5Z8ZuMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/GiftListAnimation.vue").then(m => m.default || m)
  },
  {
    name: GiftListAnimationItemD0J8r98ymqMeta?.name ?? "Room-components-animation-GiftListAnimationItem",
    path: GiftListAnimationItemD0J8r98ymqMeta?.path ?? "/Room/components/animation/GiftListAnimationItem",
    meta: GiftListAnimationItemD0J8r98ymqMeta || {},
    alias: GiftListAnimationItemD0J8r98ymqMeta?.alias || [],
    redirect: GiftListAnimationItemD0J8r98ymqMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/GiftListAnimationItem.vue").then(m => m.default || m)
  },
  {
    name: MicGiftAnimation9gYxjj8PNtMeta?.name ?? "Room-components-animation-MicGiftAnimation",
    path: MicGiftAnimation9gYxjj8PNtMeta?.path ?? "/Room/components/animation/MicGiftAnimation",
    meta: MicGiftAnimation9gYxjj8PNtMeta || {},
    alias: MicGiftAnimation9gYxjj8PNtMeta?.alias || [],
    redirect: MicGiftAnimation9gYxjj8PNtMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/MicGiftAnimation.vue").then(m => m.default || m)
  },
  {
    name: MicGiftAnimationItemV7H7o4tIUTMeta?.name ?? "Room-components-animation-MicGiftAnimationItem",
    path: MicGiftAnimationItemV7H7o4tIUTMeta?.path ?? "/Room/components/animation/MicGiftAnimationItem",
    meta: MicGiftAnimationItemV7H7o4tIUTMeta || {},
    alias: MicGiftAnimationItemV7H7o4tIUTMeta?.alias || [],
    redirect: MicGiftAnimationItemV7H7o4tIUTMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/animation/MicGiftAnimationItem.vue").then(m => m.default || m)
  },
  {
    name: AgoraAudiom1eCWCP0aYMeta?.name ?? "Room-components-audio-AgoraAudio",
    path: AgoraAudiom1eCWCP0aYMeta?.path ?? "/Room/components/audio/AgoraAudio",
    meta: AgoraAudiom1eCWCP0aYMeta || {},
    alias: AgoraAudiom1eCWCP0aYMeta?.alias || [],
    redirect: AgoraAudiom1eCWCP0aYMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/AgoraAudio.vue").then(m => m.default || m)
  },
  {
    name: DefaultBgV90axzMiZ4Meta?.name ?? "Room-components-audio-DefaultBg",
    path: DefaultBgV90axzMiZ4Meta?.path ?? "/Room/components/audio/DefaultBg",
    meta: DefaultBgV90axzMiZ4Meta || {},
    alias: DefaultBgV90axzMiZ4Meta?.alias || [],
    redirect: DefaultBgV90axzMiZ4Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/DefaultBg.vue").then(m => m.default || m)
  },
  {
    name: MicListQU4QBGhSixMeta?.name ?? "Room-components-audio-MicList",
    path: MicListQU4QBGhSixMeta?.path ?? "/Room/components/audio/MicList",
    meta: MicListQU4QBGhSixMeta || {},
    alias: MicListQU4QBGhSixMeta?.alias || [],
    redirect: MicListQU4QBGhSixMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/MicList.vue").then(m => m.default || m)
  },
  {
    name: TrtcAudiovzyS5Sd2cmMeta?.name ?? "Room-components-audio-TrtcAudio",
    path: TrtcAudiovzyS5Sd2cmMeta?.path ?? "/Room/components/audio/TrtcAudio",
    meta: TrtcAudiovzyS5Sd2cmMeta || {},
    alias: TrtcAudiovzyS5Sd2cmMeta?.alias || [],
    redirect: TrtcAudiovzyS5Sd2cmMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/audio/TrtcAudio.vue").then(m => m.default || m)
  },
  {
    name: CallTipsIx44Yx9DUdMeta?.name ?? "Room-components-CallTips",
    path: CallTipsIx44Yx9DUdMeta?.path ?? "/Room/components/CallTips",
    meta: CallTipsIx44Yx9DUdMeta || {},
    alias: CallTipsIx44Yx9DUdMeta?.alias || [],
    redirect: CallTipsIx44Yx9DUdMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/CallTips.vue").then(m => m.default || m)
  },
  {
    name: ChatEditormhpzpT1uZ0Meta?.name ?? "Room-components-ChatEditor",
    path: ChatEditormhpzpT1uZ0Meta?.path ?? "/Room/components/ChatEditor",
    meta: ChatEditormhpzpT1uZ0Meta || {},
    alias: ChatEditormhpzpT1uZ0Meta?.alias || [],
    redirect: ChatEditormhpzpT1uZ0Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatEditor.vue").then(m => m.default || m)
  },
  {
    name: ChatList8GSPOVSvpbMeta?.name ?? "Room-components-ChatList",
    path: ChatList8GSPOVSvpbMeta?.path ?? "/Room/components/ChatList",
    meta: ChatList8GSPOVSvpbMeta || {},
    alias: ChatList8GSPOVSvpbMeta?.alias || [],
    redirect: ChatList8GSPOVSvpbMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatList.vue").then(m => m.default || m)
  },
  {
    name: ChatListItemAtDVG5nwAeMeta?.name ?? "Room-components-ChatListItem",
    path: ChatListItemAtDVG5nwAeMeta?.path ?? "/Room/components/ChatListItem",
    meta: ChatListItemAtDVG5nwAeMeta || {},
    alias: ChatListItemAtDVG5nwAeMeta?.alias || [],
    redirect: ChatListItemAtDVG5nwAeMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatListItem.vue").then(m => m.default || m)
  },
  {
    name: ChatListSlideRfFrI5kuJnMeta?.name ?? "Room-components-ChatListSlide",
    path: ChatListSlideRfFrI5kuJnMeta?.path ?? "/Room/components/ChatListSlide",
    meta: ChatListSlideRfFrI5kuJnMeta || {},
    alias: ChatListSlideRfFrI5kuJnMeta?.alias || [],
    redirect: ChatListSlideRfFrI5kuJnMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/ChatListSlide.vue").then(m => m.default || m)
  },
  {
    name: InviteUserr11V2NToTpMeta?.name ?? "Room-components-InviteUser",
    path: InviteUserr11V2NToTpMeta?.path ?? "/Room/components/InviteUser",
    meta: InviteUserr11V2NToTpMeta || {},
    alias: InviteUserr11V2NToTpMeta?.alias || [],
    redirect: InviteUserr11V2NToTpMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/InviteUser.vue").then(m => m.default || m)
  },
  {
    name: OnlineUserPopupfXDvbO3BEuMeta?.name ?? "Room-components-OnlineUserPopup",
    path: OnlineUserPopupfXDvbO3BEuMeta?.path ?? "/Room/components/OnlineUserPopup",
    meta: OnlineUserPopupfXDvbO3BEuMeta || {},
    alias: OnlineUserPopupfXDvbO3BEuMeta?.alias || [],
    redirect: OnlineUserPopupfXDvbO3BEuMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/OnlineUserPopup.vue").then(m => m.default || m)
  },
  {
    name: EmojiPopupGTlGquUWLuMeta?.name ?? "Room-components-popup-EmojiPopup",
    path: EmojiPopupGTlGquUWLuMeta?.path ?? "/Room/components/popup/EmojiPopup",
    meta: EmojiPopupGTlGquUWLuMeta || {},
    alias: EmojiPopupGTlGquUWLuMeta?.alias || [],
    redirect: EmojiPopupGTlGquUWLuMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/popup/EmojiPopup.vue").then(m => m.default || m)
  },
  {
    name: RoomFootdnC4k7XgSDMeta?.name ?? "Room-components-RoomFoot",
    path: RoomFootdnC4k7XgSDMeta?.path ?? "/Room/components/RoomFoot",
    meta: RoomFootdnC4k7XgSDMeta || {},
    alias: RoomFootdnC4k7XgSDMeta?.alias || [],
    redirect: RoomFootdnC4k7XgSDMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomFoot.vue").then(m => m.default || m)
  },
  {
    name: RoomHeadLl3GBCjV0VMeta?.name ?? "Room-components-RoomHead",
    path: RoomHeadLl3GBCjV0VMeta?.path ?? "/Room/components/RoomHead",
    meta: RoomHeadLl3GBCjV0VMeta || {},
    alias: RoomHeadLl3GBCjV0VMeta?.alias || [],
    redirect: RoomHeadLl3GBCjV0VMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomHead.vue").then(m => m.default || m)
  },
  {
    name: RoomPasswordDialog8S4WxfUnCnMeta?.name ?? "Room-components-RoomPasswordDialog",
    path: RoomPasswordDialog8S4WxfUnCnMeta?.path ?? "/Room/components/RoomPasswordDialog",
    meta: RoomPasswordDialog8S4WxfUnCnMeta || {},
    alias: RoomPasswordDialog8S4WxfUnCnMeta?.alias || [],
    redirect: RoomPasswordDialog8S4WxfUnCnMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomPasswordDialog.vue").then(m => m.default || m)
  },
  {
    name: RoomSheetFCyydeHd1QMeta?.name ?? "Room-components-RoomSheet",
    path: RoomSheetFCyydeHd1QMeta?.path ?? "/Room/components/RoomSheet",
    meta: RoomSheetFCyydeHd1QMeta || {},
    alias: RoomSheetFCyydeHd1QMeta?.alias || [],
    redirect: RoomSheetFCyydeHd1QMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/RoomSheet.vue").then(m => m.default || m)
  },
  {
    name: AgoraLivet6Ewaa1SRVMeta?.name ?? "Room-components-video-AgoraLive",
    path: AgoraLivet6Ewaa1SRVMeta?.path ?? "/Room/components/video/AgoraLive",
    meta: AgoraLivet6Ewaa1SRVMeta || {},
    alias: AgoraLivet6Ewaa1SRVMeta?.alias || [],
    redirect: AgoraLivet6Ewaa1SRVMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/AgoraLive.vue").then(m => m.default || m)
  },
  {
    name: AgoraLivePkHgXDVhpny7Meta?.name ?? "Room-components-video-AgoraLivePk",
    path: AgoraLivePkHgXDVhpny7Meta?.path ?? "/Room/components/video/AgoraLivePk",
    meta: AgoraLivePkHgXDVhpny7Meta || {},
    alias: AgoraLivePkHgXDVhpny7Meta?.alias || [],
    redirect: AgoraLivePkHgXDVhpny7Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/AgoraLivePk.vue").then(m => m.default || m)
  },
  {
    name: AgoraVideoPlayerDl07UJ45vVMeta?.name ?? "Room-components-video-AgoraVideoPlayer",
    path: AgoraVideoPlayerDl07UJ45vVMeta?.path ?? "/Room/components/video/AgoraVideoPlayer",
    meta: AgoraVideoPlayerDl07UJ45vVMeta || {},
    alias: AgoraVideoPlayerDl07UJ45vVMeta?.alias || [],
    redirect: AgoraVideoPlayerDl07UJ45vVMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/AgoraVideoPlayer.vue").then(m => m.default || m)
  },
  {
    name: CountdownOverlay7bJulLO2ShMeta?.name ?? "Room-components-video-CountdownOverlay",
    path: CountdownOverlay7bJulLO2ShMeta?.path ?? "/Room/components/video/CountdownOverlay",
    meta: CountdownOverlay7bJulLO2ShMeta || {},
    alias: CountdownOverlay7bJulLO2ShMeta?.alias || [],
    redirect: CountdownOverlay7bJulLO2ShMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/CountdownOverlay.vue").then(m => m.default || m)
  },
  {
    name: LivePkdYwslCSqXEMeta?.name ?? "Room-components-video-LivePk",
    path: LivePkdYwslCSqXEMeta?.path ?? "/Room/components/video/LivePk",
    meta: LivePkdYwslCSqXEMeta || {},
    alias: LivePkdYwslCSqXEMeta?.alias || [],
    redirect: LivePkdYwslCSqXEMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/LivePk.vue").then(m => m.default || m)
  },
  {
    name: PKResultOverlay0PEQwIdplJMeta?.name ?? "Room-components-video-PKResultOverlay",
    path: PKResultOverlay0PEQwIdplJMeta?.path ?? "/Room/components/video/PKResultOverlay",
    meta: PKResultOverlay0PEQwIdplJMeta || {},
    alias: PKResultOverlay0PEQwIdplJMeta?.alias || [],
    redirect: PKResultOverlay0PEQwIdplJMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/PKResultOverlay.vue").then(m => m.default || m)
  },
  {
    name: TrtcLiveomWXMSbhgnMeta?.name ?? "Room-components-video-TrtcLive",
    path: TrtcLiveomWXMSbhgnMeta?.path ?? "/Room/components/video/TrtcLive",
    meta: TrtcLiveomWXMSbhgnMeta || {},
    alias: TrtcLiveomWXMSbhgnMeta?.alias || [],
    redirect: TrtcLiveomWXMSbhgnMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/TrtcLive.vue").then(m => m.default || m)
  },
  {
    name: VideoBackgroundWerkadMHuhMeta?.name ?? "Room-components-video-VideoBackground",
    path: VideoBackgroundWerkadMHuhMeta?.path ?? "/Room/components/video/VideoBackground",
    meta: VideoBackgroundWerkadMHuhMeta || {},
    alias: VideoBackgroundWerkadMHuhMeta?.alias || [],
    redirect: VideoBackgroundWerkadMHuhMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/VideoBackground.vue").then(m => m.default || m)
  },
  {
    name: VideoLoadMaskwzUSBBmKCgMeta?.name ?? "Room-components-video-VideoLoadMask",
    path: VideoLoadMaskwzUSBBmKCgMeta?.path ?? "/Room/components/video/VideoLoadMask",
    meta: VideoLoadMaskwzUSBBmKCgMeta || {},
    alias: VideoLoadMaskwzUSBBmKCgMeta?.alias || [],
    redirect: VideoLoadMaskwzUSBBmKCgMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/components/video/VideoLoadMask.vue").then(m => m.default || m)
  },
  {
    name: LiveAClpRpDg5rMeta?.name ?? "Room-Live",
    path: LiveAClpRpDg5rMeta?.path ?? "/Room/Live",
    meta: LiveAClpRpDg5rMeta || {},
    alias: LiveAClpRpDg5rMeta?.alias || [],
    redirect: LiveAClpRpDg5rMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/Live.vue").then(m => m.default || m)
  },
  {
    name: updateUserTimeStatusvd7BQA34ypMeta?.name ?? "Room-ts-updateUserTimeStatus",
    path: updateUserTimeStatusvd7BQA34ypMeta?.path ?? "/Room/ts/updateUserTimeStatus",
    meta: updateUserTimeStatusvd7BQA34ypMeta || {},
    alias: updateUserTimeStatusvd7BQA34ypMeta?.alias || [],
    redirect: updateUserTimeStatusvd7BQA34ypMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Room/ts/updateUserTimeStatus.ts").then(m => m.default || m)
  },
  {
    name: AudioyhetY0I9QXMeta?.name ?? "RoomApp-Audio",
    path: AudioyhetY0I9QXMeta?.path ?? "/RoomApp/Audio",
    meta: AudioyhetY0I9QXMeta || {},
    alias: AudioyhetY0I9QXMeta?.alias || [],
    redirect: AudioyhetY0I9QXMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/Audio.vue").then(m => m.default || m)
  },
  {
    name: CallKWvleZd3QfMeta?.name ?? "RoomApp-Call",
    path: CallKWvleZd3QfMeta?.path ?? "/RoomApp/Call",
    meta: CallKWvleZd3QfMeta || {},
    alias: CallKWvleZd3QfMeta?.alias || [],
    redirect: CallKWvleZd3QfMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/Call.vue").then(m => m.default || m)
  },
  {
    name: ActionSheetfROYdjTRstMeta?.name ?? "RoomApp-components-ActionSheet",
    path: ActionSheetfROYdjTRstMeta?.path ?? "/RoomApp/components/ActionSheet",
    meta: ActionSheetfROYdjTRstMeta || {},
    alias: ActionSheetfROYdjTRstMeta?.alias || [],
    redirect: ActionSheetfROYdjTRstMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ActionSheet.vue").then(m => m.default || m)
  },
  {
    name: ActivityCornerXSEnfvlNJdMeta?.name ?? "RoomApp-components-ActivityCorner",
    path: ActivityCornerXSEnfvlNJdMeta?.path ?? "/RoomApp/components/ActivityCorner",
    meta: ActivityCornerXSEnfvlNJdMeta || {},
    alias: ActivityCornerXSEnfvlNJdMeta?.alias || [],
    redirect: ActivityCornerXSEnfvlNJdMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ActivityCorner.vue").then(m => m.default || m)
  },
  {
    name: EffectGiftGYRXDvtU3KMeta?.name ?? "RoomApp-components-animation-EffectGift",
    path: EffectGiftGYRXDvtU3KMeta?.path ?? "/RoomApp/components/animation/EffectGift",
    meta: EffectGiftGYRXDvtU3KMeta || {},
    alias: EffectGiftGYRXDvtU3KMeta?.alias || [],
    redirect: EffectGiftGYRXDvtU3KMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/EffectGift.vue").then(m => m.default || m)
  },
  {
    name: EffectHeadwear5HCfLSj06mMeta?.name ?? "RoomApp-components-animation-EffectHeadwear",
    path: EffectHeadwear5HCfLSj06mMeta?.path ?? "/RoomApp/components/animation/EffectHeadwear",
    meta: EffectHeadwear5HCfLSj06mMeta || {},
    alias: EffectHeadwear5HCfLSj06mMeta?.alias || [],
    redirect: EffectHeadwear5HCfLSj06mMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/EffectHeadwear.vue").then(m => m.default || m)
  },
  {
    name: EmojiAnimationyB1DauKrd0Meta?.name ?? "RoomApp-components-animation-EmojiAnimation",
    path: EmojiAnimationyB1DauKrd0Meta?.path ?? "/RoomApp/components/animation/EmojiAnimation",
    meta: EmojiAnimationyB1DauKrd0Meta || {},
    alias: EmojiAnimationyB1DauKrd0Meta?.alias || [],
    redirect: EmojiAnimationyB1DauKrd0Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/EmojiAnimation.vue").then(m => m.default || m)
  },
  {
    name: GiftListAnimationtWsIlkEOI8Meta?.name ?? "RoomApp-components-animation-GiftListAnimation",
    path: GiftListAnimationtWsIlkEOI8Meta?.path ?? "/RoomApp/components/animation/GiftListAnimation",
    meta: GiftListAnimationtWsIlkEOI8Meta || {},
    alias: GiftListAnimationtWsIlkEOI8Meta?.alias || [],
    redirect: GiftListAnimationtWsIlkEOI8Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/GiftListAnimation.vue").then(m => m.default || m)
  },
  {
    name: GiftListAnimationItemJ7Smh8buFMMeta?.name ?? "RoomApp-components-animation-GiftListAnimationItem",
    path: GiftListAnimationItemJ7Smh8buFMMeta?.path ?? "/RoomApp/components/animation/GiftListAnimationItem",
    meta: GiftListAnimationItemJ7Smh8buFMMeta || {},
    alias: GiftListAnimationItemJ7Smh8buFMMeta?.alias || [],
    redirect: GiftListAnimationItemJ7Smh8buFMMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/GiftListAnimationItem.vue").then(m => m.default || m)
  },
  {
    name: LuckyBagBanner0Co9pd73WuMeta?.name ?? "RoomApp-components-animation-LuckyBagBanner",
    path: LuckyBagBanner0Co9pd73WuMeta?.path ?? "/RoomApp/components/animation/LuckyBagBanner",
    meta: LuckyBagBanner0Co9pd73WuMeta || {},
    alias: LuckyBagBanner0Co9pd73WuMeta?.alias || [],
    redirect: LuckyBagBanner0Co9pd73WuMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/LuckyBagBanner.vue").then(m => m.default || m)
  },
  {
    name: MicGiftAnimation08k2H5rscAMeta?.name ?? "RoomApp-components-animation-MicGiftAnimation",
    path: MicGiftAnimation08k2H5rscAMeta?.path ?? "/RoomApp/components/animation/MicGiftAnimation",
    meta: MicGiftAnimation08k2H5rscAMeta || {},
    alias: MicGiftAnimation08k2H5rscAMeta?.alias || [],
    redirect: MicGiftAnimation08k2H5rscAMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/MicGiftAnimation.vue").then(m => m.default || m)
  },
  {
    name: MicGiftAnimationItemZ3Qq2gZ70kMeta?.name ?? "RoomApp-components-animation-MicGiftAnimationItem",
    path: MicGiftAnimationItemZ3Qq2gZ70kMeta?.path ?? "/RoomApp/components/animation/MicGiftAnimationItem",
    meta: MicGiftAnimationItemZ3Qq2gZ70kMeta || {},
    alias: MicGiftAnimationItemZ3Qq2gZ70kMeta?.alias || [],
    redirect: MicGiftAnimationItemZ3Qq2gZ70kMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/animation/MicGiftAnimationItem.vue").then(m => m.default || m)
  },
  {
    name: AgoraAudiooPlXVy8lb9Meta?.name ?? "RoomApp-components-audio-AgoraAudio",
    path: AgoraAudiooPlXVy8lb9Meta?.path ?? "/RoomApp/components/audio/AgoraAudio",
    meta: AgoraAudiooPlXVy8lb9Meta || {},
    alias: AgoraAudiooPlXVy8lb9Meta?.alias || [],
    redirect: AgoraAudiooPlXVy8lb9Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/AgoraAudio.vue").then(m => m.default || m)
  },
  {
    name: DefaultBgJHOiJQfdiBMeta?.name ?? "RoomApp-components-audio-DefaultBg",
    path: DefaultBgJHOiJQfdiBMeta?.path ?? "/RoomApp/components/audio/DefaultBg",
    meta: DefaultBgJHOiJQfdiBMeta || {},
    alias: DefaultBgJHOiJQfdiBMeta?.alias || [],
    redirect: DefaultBgJHOiJQfdiBMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/DefaultBg.vue").then(m => m.default || m)
  },
  {
    name: MicList8tf1AuMcc7Meta?.name ?? "RoomApp-components-audio-MicList",
    path: MicList8tf1AuMcc7Meta?.path ?? "/RoomApp/components/audio/MicList",
    meta: MicList8tf1AuMcc7Meta || {},
    alias: MicList8tf1AuMcc7Meta?.alias || [],
    redirect: MicList8tf1AuMcc7Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/MicList.vue").then(m => m.default || m)
  },
  {
    name: TrtcAudioo9iVq1RxctMeta?.name ?? "RoomApp-components-audio-TrtcAudio",
    path: TrtcAudioo9iVq1RxctMeta?.path ?? "/RoomApp/components/audio/TrtcAudio",
    meta: TrtcAudioo9iVq1RxctMeta || {},
    alias: TrtcAudioo9iVq1RxctMeta?.alias || [],
    redirect: TrtcAudioo9iVq1RxctMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/audio/TrtcAudio.vue").then(m => m.default || m)
  },
  {
    name: CallTips83ri2wiM2FMeta?.name ?? "RoomApp-components-CallTips",
    path: CallTips83ri2wiM2FMeta?.path ?? "/RoomApp/components/CallTips",
    meta: CallTips83ri2wiM2FMeta || {},
    alias: CallTips83ri2wiM2FMeta?.alias || [],
    redirect: CallTips83ri2wiM2FMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/CallTips.vue").then(m => m.default || m)
  },
  {
    name: ChatEditor97iRI6Zcf7Meta?.name ?? "RoomApp-components-ChatEditor",
    path: ChatEditor97iRI6Zcf7Meta?.path ?? "/RoomApp/components/ChatEditor",
    meta: ChatEditor97iRI6Zcf7Meta || {},
    alias: ChatEditor97iRI6Zcf7Meta?.alias || [],
    redirect: ChatEditor97iRI6Zcf7Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatEditor.vue").then(m => m.default || m)
  },
  {
    name: ChatList1Z1BiK68RGMeta?.name ?? "RoomApp-components-ChatList",
    path: ChatList1Z1BiK68RGMeta?.path ?? "/RoomApp/components/ChatList",
    meta: ChatList1Z1BiK68RGMeta || {},
    alias: ChatList1Z1BiK68RGMeta?.alias || [],
    redirect: ChatList1Z1BiK68RGMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatList.vue").then(m => m.default || m)
  },
  {
    name: ChatListItem7brDd8KKnmMeta?.name ?? "RoomApp-components-ChatListItem",
    path: ChatListItem7brDd8KKnmMeta?.path ?? "/RoomApp/components/ChatListItem",
    meta: ChatListItem7brDd8KKnmMeta || {},
    alias: ChatListItem7brDd8KKnmMeta?.alias || [],
    redirect: ChatListItem7brDd8KKnmMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatListItem.vue").then(m => m.default || m)
  },
  {
    name: ChatListSlideVMh3tng1YPMeta?.name ?? "RoomApp-components-ChatListSlide",
    path: ChatListSlideVMh3tng1YPMeta?.path ?? "/RoomApp/components/ChatListSlide",
    meta: ChatListSlideVMh3tng1YPMeta || {},
    alias: ChatListSlideVMh3tng1YPMeta?.alias || [],
    redirect: ChatListSlideVMh3tng1YPMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ChatListSlide.vue").then(m => m.default || m)
  },
  {
    name: DetonatingBombrmltd602QkMeta?.name ?? "RoomApp-components-DetonatingBomb",
    path: DetonatingBombrmltd602QkMeta?.path ?? "/RoomApp/components/DetonatingBomb",
    meta: DetonatingBombrmltd602QkMeta || {},
    alias: DetonatingBombrmltd602QkMeta?.alias || [],
    redirect: DetonatingBombrmltd602QkMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/DetonatingBomb.vue").then(m => m.default || m)
  },
  {
    name: InviteUserNoKNdpOerZMeta?.name ?? "RoomApp-components-InviteUser",
    path: InviteUserNoKNdpOerZMeta?.path ?? "/RoomApp/components/InviteUser",
    meta: InviteUserNoKNdpOerZMeta || {},
    alias: InviteUserNoKNdpOerZMeta?.alias || [],
    redirect: InviteUserNoKNdpOerZMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/InviteUser.vue").then(m => m.default || m)
  },
  {
    name: LuckyBagn64lV07xBdMeta?.name ?? "RoomApp-components-LuckyBag",
    path: LuckyBagn64lV07xBdMeta?.path ?? "/RoomApp/components/LuckyBag",
    meta: LuckyBagn64lV07xBdMeta || {},
    alias: LuckyBagn64lV07xBdMeta?.alias || [],
    redirect: LuckyBagn64lV07xBdMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/LuckyBag.vue").then(m => m.default || m)
  },
  {
    name: OnlineUserPopup3AYuslqrKJMeta?.name ?? "RoomApp-components-OnlineUserPopup",
    path: OnlineUserPopup3AYuslqrKJMeta?.path ?? "/RoomApp/components/OnlineUserPopup",
    meta: OnlineUserPopup3AYuslqrKJMeta || {},
    alias: OnlineUserPopup3AYuslqrKJMeta?.alias || [],
    redirect: OnlineUserPopup3AYuslqrKJMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/OnlineUserPopup.vue").then(m => m.default || m)
  },
  {
    name: RoomFootAQw9osLnoQMeta?.name ?? "RoomApp-components-RoomFoot",
    path: RoomFootAQw9osLnoQMeta?.path ?? "/RoomApp/components/RoomFoot",
    meta: RoomFootAQw9osLnoQMeta || {},
    alias: RoomFootAQw9osLnoQMeta?.alias || [],
    redirect: RoomFootAQw9osLnoQMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomFoot.vue").then(m => m.default || m)
  },
  {
    name: RoomHeadz8wFqrfJXtMeta?.name ?? "RoomApp-components-RoomHead",
    path: RoomHeadz8wFqrfJXtMeta?.path ?? "/RoomApp/components/RoomHead",
    meta: RoomHeadz8wFqrfJXtMeta || {},
    alias: RoomHeadz8wFqrfJXtMeta?.alias || [],
    redirect: RoomHeadz8wFqrfJXtMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomHead.vue").then(m => m.default || m)
  },
  {
    name: RoomPasswordDialogbH2rpKCyguMeta?.name ?? "RoomApp-components-RoomPasswordDialog",
    path: RoomPasswordDialogbH2rpKCyguMeta?.path ?? "/RoomApp/components/RoomPasswordDialog",
    meta: RoomPasswordDialogbH2rpKCyguMeta || {},
    alias: RoomPasswordDialogbH2rpKCyguMeta?.alias || [],
    redirect: RoomPasswordDialogbH2rpKCyguMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomPasswordDialog.vue").then(m => m.default || m)
  },
  {
    name: RoomSheettv56y7TuHIMeta?.name ?? "RoomApp-components-RoomSheet",
    path: RoomSheettv56y7TuHIMeta?.path ?? "/RoomApp/components/RoomSheet",
    meta: RoomSheettv56y7TuHIMeta || {},
    alias: RoomSheettv56y7TuHIMeta?.alias || [],
    redirect: RoomSheettv56y7TuHIMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/RoomSheet.vue").then(m => m.default || m)
  },
  {
    name: activityCornerYGD4vg9x6IMeta?.name ?? "RoomApp-components-ts-activityCorner",
    path: activityCornerYGD4vg9x6IMeta?.path ?? "/RoomApp/components/ts/activityCorner",
    meta: activityCornerYGD4vg9x6IMeta || {},
    alias: activityCornerYGD4vg9x6IMeta?.alias || [],
    redirect: activityCornerYGD4vg9x6IMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/ts/activityCorner.ts").then(m => m.default || m)
  },
  {
    name: AgoraLivee0B633cFD7Meta?.name ?? "RoomApp-components-video-AgoraLive",
    path: AgoraLivee0B633cFD7Meta?.path ?? "/RoomApp/components/video/AgoraLive",
    meta: AgoraLivee0B633cFD7Meta || {},
    alias: AgoraLivee0B633cFD7Meta?.alias || [],
    redirect: AgoraLivee0B633cFD7Meta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/AgoraLive.vue").then(m => m.default || m)
  },
  {
    name: AgoraLivePkek0xNVXJxRMeta?.name ?? "RoomApp-components-video-AgoraLivePk",
    path: AgoraLivePkek0xNVXJxRMeta?.path ?? "/RoomApp/components/video/AgoraLivePk",
    meta: AgoraLivePkek0xNVXJxRMeta || {},
    alias: AgoraLivePkek0xNVXJxRMeta?.alias || [],
    redirect: AgoraLivePkek0xNVXJxRMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/AgoraLivePk.vue").then(m => m.default || m)
  },
  {
    name: AgoraVideoPlayerlvlyBHslZZMeta?.name ?? "RoomApp-components-video-AgoraVideoPlayer",
    path: AgoraVideoPlayerlvlyBHslZZMeta?.path ?? "/RoomApp/components/video/AgoraVideoPlayer",
    meta: AgoraVideoPlayerlvlyBHslZZMeta || {},
    alias: AgoraVideoPlayerlvlyBHslZZMeta?.alias || [],
    redirect: AgoraVideoPlayerlvlyBHslZZMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/AgoraVideoPlayer.vue").then(m => m.default || m)
  },
  {
    name: CountdownOverlay0ycQfUT00QMeta?.name ?? "RoomApp-components-video-CountdownOverlay",
    path: CountdownOverlay0ycQfUT00QMeta?.path ?? "/RoomApp/components/video/CountdownOverlay",
    meta: CountdownOverlay0ycQfUT00QMeta || {},
    alias: CountdownOverlay0ycQfUT00QMeta?.alias || [],
    redirect: CountdownOverlay0ycQfUT00QMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/CountdownOverlay.vue").then(m => m.default || m)
  },
  {
    name: LivePkkgwJNtQxwIMeta?.name ?? "RoomApp-components-video-LivePk",
    path: LivePkkgwJNtQxwIMeta?.path ?? "/RoomApp/components/video/LivePk",
    meta: LivePkkgwJNtQxwIMeta || {},
    alias: LivePkkgwJNtQxwIMeta?.alias || [],
    redirect: LivePkkgwJNtQxwIMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/LivePk.vue").then(m => m.default || m)
  },
  {
    name: PKResultOverlayspZVleE6ujMeta?.name ?? "RoomApp-components-video-PKResultOverlay",
    path: PKResultOverlayspZVleE6ujMeta?.path ?? "/RoomApp/components/video/PKResultOverlay",
    meta: PKResultOverlayspZVleE6ujMeta || {},
    alias: PKResultOverlayspZVleE6ujMeta?.alias || [],
    redirect: PKResultOverlayspZVleE6ujMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/PKResultOverlay.vue").then(m => m.default || m)
  },
  {
    name: TrtcLivejJOqor97XwMeta?.name ?? "RoomApp-components-video-TrtcLive",
    path: TrtcLivejJOqor97XwMeta?.path ?? "/RoomApp/components/video/TrtcLive",
    meta: TrtcLivejJOqor97XwMeta || {},
    alias: TrtcLivejJOqor97XwMeta?.alias || [],
    redirect: TrtcLivejJOqor97XwMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/TrtcLive.vue").then(m => m.default || m)
  },
  {
    name: VideoBackgroundpPgAFnWlPoMeta?.name ?? "RoomApp-components-video-VideoBackground",
    path: VideoBackgroundpPgAFnWlPoMeta?.path ?? "/RoomApp/components/video/VideoBackground",
    meta: VideoBackgroundpPgAFnWlPoMeta || {},
    alias: VideoBackgroundpPgAFnWlPoMeta?.alias || [],
    redirect: VideoBackgroundpPgAFnWlPoMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/VideoBackground.vue").then(m => m.default || m)
  },
  {
    name: VideoLoadMask8Xq2MUM39iMeta?.name ?? "RoomApp-components-video-VideoLoadMask",
    path: VideoLoadMask8Xq2MUM39iMeta?.path ?? "/RoomApp/components/video/VideoLoadMask",
    meta: VideoLoadMask8Xq2MUM39iMeta || {},
    alias: VideoLoadMask8Xq2MUM39iMeta?.alias || [],
    redirect: VideoLoadMask8Xq2MUM39iMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/components/video/VideoLoadMask.vue").then(m => m.default || m)
  },
  {
    name: LiveGOzMvSftCtMeta?.name ?? "RoomApp-Live",
    path: LiveGOzMvSftCtMeta?.path ?? "/RoomApp/Live",
    meta: LiveGOzMvSftCtMeta || {},
    alias: LiveGOzMvSftCtMeta?.alias || [],
    redirect: LiveGOzMvSftCtMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/Live.vue").then(m => m.default || m)
  },
  {
    name: updateUserTimeStatusOxjtSaSVRrMeta?.name ?? "RoomApp-ts-updateUserTimeStatus",
    path: updateUserTimeStatusOxjtSaSVRrMeta?.path ?? "/RoomApp/ts/updateUserTimeStatus",
    meta: updateUserTimeStatusOxjtSaSVRrMeta || {},
    alias: updateUserTimeStatusOxjtSaSVRrMeta?.alias || [],
    redirect: updateUserTimeStatusOxjtSaSVRrMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/RoomApp/ts/updateUserTimeStatus.ts").then(m => m.default || m)
  },
  {
    name: indexMn64kdgtjPMeta?.name ?? "Search",
    path: indexMn64kdgtjPMeta?.path ?? "/Search",
    meta: indexMn64kdgtjPMeta || {},
    alias: indexMn64kdgtjPMeta?.alias || [],
    redirect: indexMn64kdgtjPMeta?.redirect,
    component: () => import("/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/pages/Search/index.vue").then(m => m.default || m)
  }
]